import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import List from './List'
import Show from './Show'

const User = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <List />
      </Route>
      <Route exact path={`${path}/:id`}>
        <Show />
      </Route>
    </Switch>
  )
}

export default User
